var React = require('react');

function ArrowForward (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Mobilmeny","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","transform":"translate(-296 -64)"},React.createElement("g",{"id":"Group-2","transform":"translate(0 64)","fill":"#000"},React.createElement("g",{"id":"angle1","transform":"matrix(0 -1 1 0 296 13.667)"},React.createElement("path",{"d":"M13.802.863l-.695-.679a.445.445 0 00-.64 0L7 5.521 1.533.184a.444.444 0 00-.64 0l-.695.68a.424.424 0 00-.14.312c0 .117.047.222.14.312L6.68 7.816a.445.445 0 00.64 0l6.482-6.328a.424.424 0 00.139-.312.425.425 0 00-.139-.313z","id":"Shape","fill":"#171717"})))));
}

ArrowForward.defaultProps = {"width":"8","height":"14","viewBox":"0 0 8 14"};

module.exports = ArrowForward;

ArrowForward.default = ArrowForward;
